import React, {useEffect, useRef} from 'react'
import {useAuth} from '../../../../app/modules/auth'
import {UspsStripeBanner} from './UspsStripeBanner'
import {BaeGuardStripeBanner} from './BaeGuardStripeBanner'

// Global header stripe stack. Render order == stacking priority (top → bottom).
// Rendered at the very top of MasterLayout (above `page`), spanning full width.
// Its height is published to the CSS var --global-banner-height so the fixed
// aside and header can offset below it (banners are dismissible → height varies).
const GlobalBannerStack: React.FC = () => {
  const {currentUser} = useAuth()
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const root = document.documentElement
    const el = ref.current
    if (!el) {
      root.style.setProperty('--global-banner-height', '0px')
      return
    }
    const update = () => root.style.setProperty('--global-banner-height', `${el.offsetHeight}px`)
    update()
    const observer = new ResizeObserver(update)
    observer.observe(el)
    return () => {
      observer.disconnect()
      root.style.setProperty('--global-banner-height', '0px')
    }
  }, [currentUser])

  if (!currentUser) return null

  return (
    <div ref={ref}>
      <UspsStripeBanner />
      <BaeGuardStripeBanner />
    </div>
  )
}

export {GlobalBannerStack}
